<template>
<v-card tile v-bind='attrs' height='100%' >
  <v-img
      height="125"
      :src="productCoverPicture" >
    <v-chip color='warning' class='mx-2' x-small label v-if='item.archived' >Archived</v-chip>
    <v-chip color='info' class='mx-2' x-small label v-if='item.private' >Private</v-chip>
    <v-chip color='info' class='mx-2' label x-small v-if='item.is_online' >Virtual</v-chip>
    <v-chip color='info' class='mx-2' label x-small v-if='item.comes_to_you' >Flexible</v-chip>

    <v-btn absolute top right small
      @click='$emit("edit", item)' >Edit</v-btn>
  </v-img>
  <v-list>
    <v-list-item >
      <v-list-item-content>
        <v-list-item-title v-text='item.title' />
        <v-list-item-subtitle >
          {{item.duration}} minutes.
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        {{ formatCurrency(item.currency, item.price) }}
        <v-list-item-action-text >Price
          <span v-if="hasAutoCodes" >(Automated)</span>
        </v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>
  </v-list>
  <v-card-text class='pa-2'>
    <p
      v-if='item.description && item.description !== "{}"'
      class='caption pa-0' >{{item.description}}</p>
    <!-- <template v-for='loc in item.locations' >
      <location-chip class='mr-2'
        @selected='$emit("location:clicked", loc)'
        v-if='loc.id'
        :space-id='spaceId'
        :location-id='loc.id'
        :attrs="{xSmall: true}"
        :key='loc.id' />
      <location-chip
        v-else class='mr-2'
        @selected='$emit("location:clicked", loc)'
        :space-id='spaceId'
        :location-id='loc'
        :attrs="{xSmall: true}"
        :key='loc' />
    </template> -->
  </v-card-text>
  <v-card v-if='item.locations && item.locations.length > 0' flat >
    <v-card-title class='py-0 overline grey lighten-4' >Locations</v-card-title>
    <!-- <pre v-text="item" /> -->
    <v-card-text v-for='(loc, index) in item.locations' :key="index" >
      <location-chip class='mr-2'
        @selected='$emit("location:clicked", loc)'
        v-if='loc.id'
        :space-id='spaceId'
        :location-id='loc.id'
        :attrs="{xSmall: true}"
        :key='loc.id' />
      <location-chip
        v-else class='mr-2'
        @selected='$emit("location:clicked", loc)'
        :space-id='spaceId'
        :location-id='loc'
        :attrs="{xSmall: true}"
        :key='loc' />
    </v-card-text>
  </v-card>
  <v-card tile flat
    v-if='hasAutoCodes'
    @click='$emit("edit", item)' >
    <v-card-title class='py-0 overline grey lighten-4' >
      Coding
    </v-card-title>
    <v-data-table dense hide-default-footer hide-default-header
      :headers='[{value:"icd10"},{value:"process"},{value:"price", align: "end"}]'
      :items="item.auto_codes" >
      </v-data-table>
    <v-divider />
    <v-card-actions class="pr-4" >
      <v-spacer/>
      <strong class="mr-1" >Total: </strong>
      {{ formatCurrency(currency, codeTotal) }}
    </v-card-actions>
  </v-card>
  <v-footer class="pl-2" absolute bottom >
    <v-chip x-small outlined label >#{{item.id}}</v-chip>
  </v-footer>
</v-card>
</template>
<script>
import LocationChip from '@/components/listitems/LocationChip.vue'

export default {
  name: 'AppointmentCardListItem',
  components: {LocationChip},
  props: {
    item: { type: Object, required: true },
    attrs: { type: Object, default: () => {} },
    withEdit: { type: Boolean, default: true },
    withDelete: { type: Boolean, default: true },
    withActions: { type: Boolean, default: false }
  },
  computed: {
    productCoverPicture () {
      if (this.item && this.item.background_picture) {
        return this.item.background_picture
      }
      return 'https://images.unsplash.com/photo-1510024161681-8a1f66ed1a25?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjExOTkxfQ'
    },
    spaceId () {
      if (this.item.space) { return this.item.space }
      if (this.item.service) { return this.item.service }
      return ''
    },
    hasAutoCodes () {
      return (this.item && this.item.auto_codes && this.item.auto_codes.length > 0)
    },
    codeTotal () {
      let codes = this.getObjectPath(this.item, 'auto_codes')
      if (codes) {
        return codes.reduce((previous, current) => { return previous + parseFloat(current.price) }, 0)
      }
      return 0
    }
  }
}
</script>
